import { retrieveGlobalSearchV4 } from "@/lib/data/requests/search/global-search";
import { queryKeys } from "@/lib/data/static/query-keys";

import { getSearchScope } from "./scope";
import type { RetrieveGlobalSearchInput } from "@/lib/data/requests/search/global-search";
type RetrieveGlobalSearchQueryOptionsInput = RetrieveGlobalSearchInput;

export const retrieveGlobalSearchQueryOptions = ({
  query,
  limit = 20,
  entityType,
  cursor,
}: RetrieveGlobalSearchQueryOptionsInput) => ({
  queryKey: [
    queryKeys.globalSearch,
    getSearchScope(),
    { query, limit, entityType, cursor },
  ],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveGlobalSearchV4({ query, limit, entityType, cursor }, signal),
  enabled: query.trim().length >= 2,
});
